import goog from 'google-libphonenumber';
const i18n = goog;

import 'intl-tel-input/build/js/intlTelInput-jquery';
import 'intl-tel-input/build/js/utils';
import 'intl-tel-input/build/css/intlTelInput.css';

window.i18n = window.i18n ?? i18n;